<template>
  <div>
    <form @submit.prevent.stop="submit()">
      <div class="columns is-multiline">
        <div class="column is-12">
          <span class="label">Date de recherche</span>
          <div class="field has-addons">
            <div class="control">
              <a class="button is-square is-static is-border is-min-width-0">
                <span class="icon"><i class="fas fa-calendar-alt"></i></span>
              </a>
            </div>
            <div class="control is-expanded has-icons-right">
              <flat-pickr :config="configDate" v-model="researchDate" class="input is-radiusless" name="researchDate"
              ></flat-pickr>
            </div>
            <div class="control">
              <a class="button is-square is-radiusless" @click="researchDate = null">
                <i class="fal fa-times"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="column is-12 is-paddingless-top">
          <label class="label">Type de recherche</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="s.research_type">
                <option>Sélectionner un type</option>
                <option v-for='(trim, i) in contactResearchList' :value="trim.value" :key="i">{{trim.label}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-12 is-paddingless-top is-paddingless-bottom" v-if="filteredAllRegions && filteredAllRegions.length">
          <div class="no-placeholder">
            <!-- <label for="" class="label">Localisation *</label> -->
            <r-label :label="'Localisation'" :value="addressList"></r-label>
            <multiselect v-model="addressList" name="states" :options="filteredAllRegions"
                          class="multiselect--option-ico"
                          open-direction="bottom"
                          :errors-bag="errors"
                          :multiple="true" :searchable="true" :show-labels="false"
                          :close-on-select="false"  :placeholder="''"
                          group-values="states" group-label="region" :group-select="true"
                          :customLabel="v => stateCustomLabel(v)"
                          label="name" track-by="code" v-validate="'required'">
              <span slot="noResult">Oups! {{defaultStateLabel.error}}</span>
              <span slot="placeholder" class="multiselect__placeholder">Région et {{defaultStateLabel.label}}</span>
              <span slot="noOptions">La liste est vide</span>
            </multiselect>
          </div>
        </div>
        <div class="column is-12">
          <label class="label">Type du lot</label>
          <multiselect v-model="setLotTypes" id="lot_types" label="label" track-by="value" :options="typesList"
                          :searchable="false" :close-on-select="false" :show-labels="false" :clear-on-select="true"
                          :placeholder="''"
                          class="multiselect--option-ico"
                          :multiple="true">
            <span slot="placeholder" class="multiselect__placeholder">Sélectionnez le type de lot</span>
            <span slot="noOptions">La liste est vide</span>
          </multiselect>
        </div>
        <div class="column is-12 is-paddingless">
          <!-- <v-input id="budget_max" name="budget_max" @input="val => s.budget_max = val"
              :model="s.budget_max" v-validate="'decimal:2'"
              label="Budget Max" :errors-bag="errors" data-vv-value-path="val"
              data-vv-as="Budget Max">
          </v-input> -->
          <label class="label is-padding-left">Budget Max</label>
          <div class="column is-12 columns is-variable is-1 is-multiline is-paddingless-top">
            <div class="column is-6 is-paddingless-top is-paddingless-left is-padding-bottom-xsmall"
                 v-for="(budget, i) in searchBudgetMaxList" :key="i">
              <input :id="budget.value" v-model="budgetMax" :value="budget.value" name="typeRdv"
                      checked="checked" class="checkradiocase is-primary is-fullwidth" type="radio">
              <label :for="budget.value">{{budget.label}} {{$currency}}</label>
            </div>
          </div>
        </div>
      </div>
    </form>
    <span v-if="canSubmit"></span>
  </div>
</template>

<script>
  import { DefaultValues } from '@/mixins'
  import { compact } from 'lodash'

  const emptySearch = {
    buyer: null,
    research_type: null,
    lot_types: [],
    addresses: [],
    budget_max: null
  }

  export default {
    name: 'SearchModal',
    data () {
      return {
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'd/m/Y'
        },
        addressList: [],
        setLotTypes: [],
        newAddress: {},
        researchDate: null,
        budgetMax: null
      }
    },
    mixins: [DefaultValues],
    props: {
      source: {
        type: Object
      },
      contact: {
        type: Object,
        required: false
      },
      fromQuickview: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      s () {
        return this.search
      },
      addressValid () {
        return this.addressList.length !== 0
      },
      canSubmit () {
        let canSubmitSearch = this.errors.any() === false && this.addressValid
        this.$emit('iCanSubmit', canSubmitSearch)
        return canSubmitSearch
      }
    },
    methods: {
      close () {
        this.$emit('close', null)
      },
      addAddress (v) {
        if (v && v.address) this.newAddress = Object.assign({}, v.address)
        if (this.newAddress.city && this.newAddress.zip_code) {
          this.addressList.push(Object.assign({}, this.newAddress))
        }
      },
      validate (cb) {
        this.$validator.validateAll().then((result) => {
          cb(result)
        })
      },
      submit () {
        if (!this.addressList.length && !this.newAddress.city) {
          return this.$notify({
            type: 'is-danger',
            text: 'Veuillez saisir au moins une localisation.'
          })
        }
        this.s.states = this.addressList.map(x => {
          return {state_code: x.code, state: x.name}
        })
        this.s.lot_types = this.setLotTypes.map(x => x.value)
        this.s.budget_max = this.budgetMax
        this.s.research_date = this.researchDate

        this.validate((valid) => {
          if (valid) {
            if (this.s.budget_max && (this.s.budget_max === 400000 || this.s.budget_max === 4000000)) {
              this.s.budget_max = null
            }
            this.$api.contactService.postResearches(this.s).then(r => {
              if (this.source) {
                this.$api.contactService.deleteResearches(this.source.pk).then(d => {
                  r.data.deletedPk = this.source.pk
                  this.$emit('submit', r.data)
                })
              } else {
                this.$emit('submit', r.data)
              }
            })
          } else {
            this.$notify({
              type: 'is-danger',
              text: 'Erreur Le formulaire est invalide.'
            })
          }
        })
      },
      deleteAddress (i) {
        this.addressList.splice(i, 1)
      },
      stateCustomLabel (v) {
        if (this.$configs.COUNTRY === 'FRA') {
          return `${v.code} - ${v.name}`
        } else {
          return v.name
        }
      }
    },
    created () {
      if (this.source) {
        this.search = Object.assign({}, this.source)
        this.addressList = compact(this.states.map(x => {
          if (this.search.states.map(x => x.state_code).includes(x.code)) return x
        }))
        this.search.lot_types.forEach(el => this.setLotTypes.push({label: el, value: el}))
      } else {
        this.search = Object.assign({}, emptySearch)
      }
      this.$set(this.search, 'buyer', this.contact.pk)
      if (this.s.budget_max) {
        this.budgetMax = this.searchBudgetMaxData[this.s.budget_max] ? this.searchBudgetMaxData[this.s.budget_max].value : null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/quickview/SearchModal.vue